/**
 * Mirrors packages/amgdragontiger_v2/lib/core/constants/api_constants.dart
 * + game_constants.dart for endpoints, game keys, and the reference resolution
 * used by the Flutter web build.
 */
export const API_BASE = 'https://staginggameapi.tbgcablecar.xyz/api';

export const Endpoints = {
  login: `${API_BASE}/action/login`,
  openGame: `${API_BASE}/action/opengame`,
  checkBalance: `${API_BASE}/action/balance`,
  getInfo: `${API_BASE}/action/getinfo`,
  placeBet: `${API_BASE}/action/bet`,
  getHistory: `${API_BASE}/action/bethistory`,
} as const;

export const GAME_KEY_SINGLE = 'DTA1';
export const GAME_KEY_MULTI = 'DTAM';
export const MULTIPLAYER_HUB_URL =
  'https://staginggameapi.tbgcablecar.xyz/dragontigerhub';
export const DEFAULT_AGENT_ID = 'Agent1';

/** Reference stage size — mirrors apps/amg_dragontiger_v2/web/index.html */
export const REF_WIDTH = 1792;
export const REF_HEIGHT = 828;

/**
 * Hard-coded test credentials — match the Flutter `LobbyScreen` defaults
 * (packages/amgdragontiger_v2/lib/presentation/screens/lobby_screen.dart).
 * The lobby logs in with these and password `123456`, then calls openGame.
 */
export const DEFAULT_USER_NAME = 'user2';
export const DEFAULT_PASSWORD = '123456';

/** Default game config — used until /action/getinfo overrides. */
export const DEFAULT_GAME_CONFIG = {
  minBet: 1000,
  maxBet: 100000,
  chipValues: [1000, 5000, 10000, 50000, 100000, 500000] as const,
};

/** ms — auto-advance new round after showing the result panel */
export const NEW_ROUND_DELAY_MS = 4500;
/** ms — delay between Dragon and Tiger card reveal animations */
export const CARD_REVEAL_STEP_MS = 900;
/** ms — bettingClosed → cardReveal */
export const REVEAL_START_DELAY_MS = 600;
